import { components } from '../../tokens/components/bluestone';
import { DeprecatedTheme } from '../types';
import colorsTR from './colors/base/TR';
import alertTokens from './components/alert.tokens';
import createButtonTokens from './components/button.tokens';
import createCalendarTokens from './components/calendar.tokens';
import checkboxTokens from './components/checkbox.tokens';
import drawerHeaderTokens from './components/drawerHeader.tokens';
import inputTokens from './components/input.tokens';
import radioButtonBoxTokens from './components/radioButton.tokens';
import sliderTokens from './components/slider.tokens';
import ED from './ED';

const colorsBrand = { 0: '#FE7100', 1: '#E66700', 2: '#BE5400' };
const brandSecondary = '#5C9FAB';
const uniqueBackground = '#00A7CC';
const uniqueForeground = '#006C86';
const lightOrange = '#FED4B3';

const {
  colors: colorsED,
  radii,
  borders,
  space,
  fontSizes,
  sizes,
  lineHeights,
  fontWeights,
} = ED;

const colors = {
  ...colorsED,
  ...colorsTR,
  brandPrimary: colorsBrand,
};
const fontSizeBody = fontSizes.body;

const button = createButtonTokens({
  colors,
  colorsBrand,
  radii,
  borders,
  space,
  fontSizeBody,
});
const drawerHeader = drawerHeaderTokens({
  colorsBrand,
  colors,
  borders,
  space,
});
const slider = sliderTokens({
  colors,
  colorsBrand,
  sizes,
  space,
  fontSizeBody,
});
const checkbox = checkboxTokens({
  borders,
  colors,
  colorsBrand,
  space,
  lineHeights,
  fontSizeBody,
});
const radioButton = radioButtonBoxTokens({
  borders,
  colors,
  colorsBrand,
  lineHeights,
  fontSizeBody,
  fontWeights,
});
const input = inputTokens({
  fontSizes,
  lineHeights,
  colors,
});
const alert = alertTokens({ colors, borders });
const calendar = createCalendarTokens({ colors });

const TR: DeprecatedTheme = {
  ...ED,
  colors: {
    ...colors,
    text: colors,
    brandSecondary,
    appBanner: {
      bg: '#40a1b3',
      bt: '#338695',
      image: null,
      uniqueBackground,
      uniqueForeground,
    },
    banner: {
      bg: ED.colors.neutrals[0],
      fg: colorsBrand[2],
      gradient: [colors.neutrals[0], colors.neutrals[0]],
    },
    button: button.colors,
    drawerHeader: drawerHeader.colors,
    slider: slider.colors,
    checkbox: checkbox.colors,
    radioButton: radioButton.colors,
    brandedProgressBar: brandSecondary,
    decorationLine: {
      ...colors.decorationLine,
      default: brandSecondary,
    },
    switchSlider: {
      ...colors.switchSlider,
      checkedBg: colorsBrand[1],
    },
    lightButtonBgColor: lightOrange,
    darkButtonTextColor: colorsBrand[2],
    input: input.colors,
    alert: alert.colors,
    calendar: calendar.colors,
  },
  borders: {
    ...ED.borders,
    alert: alert.borders,
  },
  components,
};

export default TR;
